import { CustomListAttrs, CustomListItem } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 自定义列表组件类 */
export class CustomListComponent extends BaseComponent<
  CustomListAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        CustomListAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.custom_list;
  }

  /** 获取自定义列表数据列表 */
  public getCustomListItems(): CustomListItem[] {
    return (
      this.lang_attrs?.list?.filter((item) => {
        if (item.status !== 1) return false;

        // // Check recharge_type
        // if (item.recharge_type === 1) return true;
        // if (item.recharge_type === 2 && userStore.userInfo?.is_pay === 1)
        //   return true;
        // if (item.recharge_type === 3 && userStore.userInfo?.is_pay === 0)
        //   return true;

        return true;
      }) || []
    );
  }
}
